module.exports = __webpack_public_path__ + "static/media/ic_heart.81c654e6.svg";